<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>

    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>

    <el-divider direction="vertical"></el-divider>
    <el-tag>输入起止日期：</el-tag>

    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        fixed
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        v-if="['ACCOUNT'].includes(this.values)"
        prop="reportDate"
        width="120"
        label="按天维度查询时返回">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="uuid"
        width="120"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"
        width="120"
        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"
        width="100"
        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        label="撞线警告">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.flag">警告警告 </el-tag>
          <el-tag type="success" v-else-if="!scope.row.flag">平安 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"
        :formatter="ChangeToPercentage"
        label="点击率">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="80"
        prop="spent"
        label="花费">
      </el-table-column>
      <el-table-column
        sortable
        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <el-table-column
        prop="customPayCount"
        label="自定义付费数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdyff"
        label="自定义付费数成本">
      </el-table-column>
      <el-table-column
        prop="reactivation"
        label="自定义拉活数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdylh"
        label="自定义拉活数成本">
      </el-table-column>
      <el-table-column
        prop="customRetainCount"
        label="自定义次留">
      </el-table-column>
      <el-table-column
        prop="zdycl"
        label="自定义次留成本">
      </el-table-column>
      <el-table-column
        sortable
        prop="CVR"
        :formatter="ChangeToPercentage"
        label="转化率">
      </el-table-column>
      sortable
      <el-table-column
        prop="CLR"
        :formatter="ChangeToPercentage"
        label="次留率">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"

      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" v-if="flag" type="text" size="small">查看</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">定时</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="时段成本"
      :visible.sync="table"
      direction="rtl"
      size="50%">
      <el-table :data="HourList"
                v-loading="loading"
      >
        <el-table-column property="reportTime" label="日期" width="150"></el-table-column>
        <el-table-column property="campaignName" label="计划名称" width="200"></el-table-column>
        <el-table-column property="nameid" label="名称"></el-table-column>
        <el-table-column property="spent" label="花费"></el-table-column>
        <el-table-column property="formsubmitCount" label="表单提交量" width="200"></el-table-column>
        <el-table-column property="chengben" label="成本" width="200"></el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="修改开启时间" :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog1">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {


  data() {
    return {
      loading:false,
      isDisable:false,
      userUalue:'',
      options1: [
       {
        value: 'zuoen',
        label: '卓恩',
        children: [{
          value: 'marryu',
          label: '迈优MARRYU',

        },{
            value: 'ljs',
            label: '杭州英博'
          },{
            value:'kxz',
            label: '上海英博'
          },{
          value: 'bxmcid',
          label: '变现猫CID'
        },
          {
            value: 'fkysk',
            label: '富康养生课'
          },{
          value: 'wdohx',
          label: '维迪欧唤醒'
        },{
          value: 'bxmbj',
          label: '变现猫白酒'
        }
          ,{
          value: 'ywd',
            label: '鹦鹉岛'
          }
          ,{
            value: 'ygxys',
            label: '御贡西洋参'
          },{
            value: 'dzkq',
            label: '德中口腔',
          },
          {
            value: 'tabj',
            label: '推啊白酒',
          },{
            value: 'hxbj',
            label: '黄信白酒'
          },{
            value: 'xyxys',
            label: '新野西洋参'
          },
          {
            value: 'hmhx',
            label: '鸿梦唤醒'
          },{
            value: 'smyxys',
            label: '宋美玉西洋参'
          },{
            value: 'ylmc',
            label: '雅莉莓茶'
          },{
            value: 'zhmc',
            label: '宗桓莓茶'
          },{
            value: 'xmlmc',
            label: '彭总新美丽莓茶'
          },{
            value: 'xmmc',
            label: '喜妹莓茶'
          },
          {
            value: 'jqsq',
              label: '金七三七'
          }
          ,
          {
            value: 'cpcid',
            label: '陈皮CID'
          }
        ]

      }],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],


      hmhx:[
        '588bf065912cc5e57831',
        '98cb95da54220a709d8e',
        '6780cf3331500eb039ec',
        'ce1faddcb99dfbfb0854',
        'fa569ebe5ce3f5401c0a',
        '76b3f5397fd442f590a4',
        '2b37571e482a57e4db59',
        '6a1b2ea550e446f23b1f',
        '02554be069f0d77ff037',
        '5876be07c09a050e3160',
        '7066acb8126d6f055155',
        '69ffe90192b2f8abd466',
        'fa0aa5d0ff44273d16fd',
        '123fc9b9679ecb1e12ce',
        '0f3e2d6ede406c28993c',
        '65acac7ef8238c7abc3c',
        '1e477c3d36a4323cc94f',
        '91a377ea84047d8cfd7b',
        '8887e8c1e79b17ab49c3',
        '0fc2a75d941053327c70',
        '4952ec6b5d218e73435c',
        '1821e1ca52bf37ad57e4',
        'e5f5d0639c4cc5988c17',
        'd092582736e27d197a12',
        '521f9959c6e672e1c80e',
        '7776a1dfe686189d599e',
        '5216ba6e179771946579',
        'c8186a3d4c504e29c83b',
        '5f969a3175c7a6cb22a9',
        'b1e118cc4873e1e56bb4',

        '73afa60f316cdb6195a0',
        'f71dc0d5f777db71a671',
        'b7ac2b7d981edce6cac9',
        '053c28b7278a93802a2c',
        '92f2f197fd56404ec387',
        '672435eb12f532c48864',
        'a078c91189edc3ec77da',
        '6c7578dc4ce43f65c1a6',
        '204ec8103e5876e69d39',
        '3495dd998da9a5a8bad1',
        'b052e0a84a26bbf59e57',
        '5f28243f2c3ee73b172e',
        '7f8b4c24b1793c5c529a',
        'be0833c4dfb17bba3550',
        '1d0c7387f39709c9a6f6',
        '9a56cb026ddf79d28aab',
        '2b1b6b2f91b5d1fa6778',
        '6f3c3bbed24e87c30120',
        'db82e20c8c21e464e9b9',
        '69e1614fc241264aae09',
        'e170c52de4af98eb8a4b',
        '0942e80aec2a09f0394a',
        'df42d286ed54e51a5b5b',
        '5c07d51768230fe34693',
        '5685deb2750476558275',
        '5fc2d193c4137d30cfae',
        '437c4a1a0ac5bbd303d7',
        'bc4437cf14bfe234660a',
        'f2dd005f96b79b2b95ec',
        'ee81848b0537bed0cd86',
       ' 20dd9ae12e2e07cc22c7',
        'e30e465eb5590bfad54f',
        '520e3b89af2735d2cbc7',
        'cd97efa2312dfdf1c087',
        'faf9a20ed8d204540385',




      ],
      hmhxtoken:[
        'f3999f439c5186bdccada46e0753dc59ff66a01acfa40c611a85a96b101d53cb'
      ],

      cpcid:[
        'bb9d39384818174ad99b',
        '3c8ad31d16b1159f7472',
        'e060a59b275282d10f40',
        '93280ee74f84ef4a9735',
        'cacbd3a4f7d5beb375e9'
      ],
      cpcidtoken:[
        'dbb164d1eaf6ddb5f2ee5eb18be5a28fa8a8bdc765edb32763d54b2b913281fc'
      ],

      jqsq:[
        '4534b3965d819327ed0d',
        'c14c2f167e4cfd808f7d',
        '1ba48a2747ded091617',
        '0449ab0684a302e50edd',
        '09e9d17d7cbc04f0a478',
        'dad021a18193b3a0547a',
        'fc12d3e8684a24eb253c',
        '63478398d00dfa759416',
        '8db4b86cd1345d918331',
        '94dcad4b4eea79ab76c8',


      ],
      jqsqtoken:[
        '2f226e21c2bd8ea6bd1023880b9e6d8977aadb505173c6d26ed52fad0f68d2a5'
      ],
      xmmc:[
        '674a5969dd4b83114ef7',
        '78c4bc834228419226c8',
        '263f84df8e3d258b00a3',
        '62976fa2d84f4f89c3df',
        'c9f9c3ab33b58647848f',
        '3758d33ca55b89d87672',
        'de70c83b5ecbbbf32a8a',
        'ab0c53ae6fb19d4bb14a',
        '032d030c7cdeca825892',
        'f3216b69f4aa759ea8ca',
        '9455e708af8456ffceea',
        '7910f1131cb7713ed952',
        '4022a400b69e3ecf02cd',
        'eeea0755f88dbe0f60c3',
        'a699d0eea59766df3e25',
        '1985edcb62ac0b76e6ab',
        'bf06f51fd111189e8b84',

      ],
      xmmctoken:[
        '88753b19fe2cbd8ab6399026507f6e2ca1f6a65dd7c33267ceffcab93eb197ca'
      ],
      xmlmc:[
        'ec864766ad2f5076ad22',
        '29beb177f3fc000034f0',
        '989f16281decc876340c',
        '0bfcd926b3e89fbaa470',
        'bdd69714545f2d1f2d87',
        '7d878cbdd86ace3af89f',
     //   'fdc91627a26a3d67dbcd',
        '3e1219c48f268ae2eddb',
        '52fde1234812a31c4dd8',
        '6cfc1a849d4be562ea7c',
        'e61bbc1a6639f666497e',
        'a7c4412e831766de846e',
        '23347a46487adabe8837',
      ],
      xmlmctoken:[
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e'
      ],
      fkysk:[
        'a48e466044d37dc04403',
        '93fca25b93ac32dc1de0',
        '4e8d0443187f0fb0e2b6',
        'daae89b2f74bce22cd3f',
        '16aadd48eccc05dee959',
        '3b549931e9f439765a61',
        '70929ba7bda28d795277',
        'b654d1ba75a196042f40',
        '7d9b4ba07ad0ed040228',
        '66a389e6c2e9e5d6e9d8',
        'e08f77ff6b7352e796a0',
        '0aa2db775c495c2ab989',
        '31feef3478e80332d8cd',
        'a538ba4b4556c7a96f3a',
        '8f14055277fc1847a8d8',
        '67d6608069067115466c',
        'df7a5055387e425ad382',
        'c3ad30c88fb94b6698dc',
        '325a4a9fb8fe40c21b44',
        'bf06d11b81a64931b43c',

        '833b8386343fb7bcc640',
        '212824899eba7a9ae7d1',
        '2978a0d95d70c6276e0d',
        '3e80093f400eee2eb900',
        '801aa109f038acd7790e',
        '88310d57c869d4cb1b92',
        'afe995fa6408cb6f2743',
        'b6411f9367a5f340f700',
        'c1806e029a207dac10fa',
        'cbc96addc5c8d608bf63',
        'b42137e435b3effc0b09',
        '1f20aeec300b9f39b8dd',
        '111e242699b0121e0a80',
        'eb6ab0fa7127903fb2ef',
        '5d9e97f6d2f57ff7d19c',
        '79d13a9023d2838d9f99',
        '8a634de4860ac1173b44',
        'ec873b88811cad6fa89b',
        '0338e56e46a1a7b6935d',
        '1b1c51cab201757cc99c'
      ],
      fkysktoken:[
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e'
      ],
      ylmc:[

        '5222806911b41dc2adcb',
        'efe308849c4313ef175b',
        'ead90405a6f579d98fe0',
        '3fecc489902f59ee59c2',
        'e7799c3817da1260a1cc',
        'ca9c30ce82ecb7c274fd',
        '826f278f9d0ff57f1cef',
        'c9d56fbec5723f6d37ec',
        '352b60f291e7eb436024',
        'ec8118167e60447d8495',
        '1e3ccc45ec538040e5fa',
        '5450fab018ff8f8a9f75'
      ],
      zhmc:[
        '73951706fd6cab90ba83',
        '28855c167a8102f90a4a',
        '20f34139c821aa7f2ef5',
        '7469041d6932d4fd95f5',
        '3eccdbdc39a5b9ba6c91',
        '446762b182a55b630421',
        '2aab315cbb0f7e4cb141',
      ],
      zhmctoken:['838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2'],
      ylmctoken:['f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943'],
      smyxys:['ad0cdd10035550b0933b','25285ff8aa190be524b6',
        '1f983d93edf9f7674c1c','cf8eb703abf3a35c396f','8c7501a9166980adb02f',

        '739cbde6964476e60a87',
        '001cc29d94c74736eb8b',
        '9d713dfb7a06b37c4aeb',
        'e9c972f7ad7fced9cb07',
        '335f6a9c4e16ae57d657',
      ],

      smyxystoken:['f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943'],
      xyxys:['8fae54e9507d11f63dbe','636c0a1057af493ab5ad'],

      xyxystoken:['f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943'],
      hxbj:[
        'a6bd959677f9a33f9830',
        '643d1b8bcd165d8a3f98',
        '5b9ac45a808190b4b3cc',
        '40f3867373f81d932f21',
        'e5600832c34543f8589f',
        '1986b792b7f66981ebdd',
        '05e640a69a143e62c675',
        '3beb14217ac663e3a791',
        '479cd4b898286959a699',
        'bd437f6b0ec6887a7b41',
        '62676b5931ad6e843a0c',
        'fff52e7a02f1200eca6b',
        '7b4d053e85e124dced89',
        '909dc175565ae7b72bb5',
        'a5fea05d32adc599128f',
        '9cebeee2f12b28748066',
        '0c78d2f1f37b9b8b5342',
        'cff291d40f768d544bc3',
        'dceba07d532b14983e8e',
        '62697d0a779ab9ceec10',
        '894ac7bec9cbf65de0e8',
        '7f70647244cc3d802417',
      ],

      hxbjtoken:['f703e415c61027e11382cef7ff13624649521fc353280659924c28a16735749e'],
      ygxys:['392333596d8283948672','a926ebfb0a02f3f578bd','f9c1f87cb57ec485fd8b','aa09df75eca9ab91f347','827c7249962c974cc8ec',

        'ac7bae3e3f1988a89983',
        'e561d1291aff93d6d2e5',
        '54589d7a892729813b49',
        '2f89c81db8fc395e89f2',
        '54fae66b9768d9473439',
        '0441400d7eefae9c9378',
        'ab424bad78ed178528f9',
        'f58706c3285f1ea43443',
        'b5858cfb7773cdeba4b4',
        'fa0e4f9c91a0a34d5520',
        'b43ef8e3a433660287dc',
        '735e55059e3838f62530',
        '38fa85563cf06f20954e',
        '6af223c84c01503abeb1',
        '8ef57f48098c74d69b40',
      ],

      ygxystoken:['d6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152'],
      //数据
      xiaoqing:['1b39ec617071e23de1c865ea772c1eace6392f195781a9128405a0d19920ea3d','e02e2618fc793dc152d82ce2ded524f97d775e108b295a1ce338117ca096fd5f',
        'cb40eea503b274dadca8c71634393d407af24c9c0c2aa095c7c8665ec07f1d4e','b76f84d0eb68aea6faee58e82ad7cc652f7187eb23ef1b9d3d7f8eeb09cfba10','155c2a24cccce986528990fa6401d22ae727a8d49dc98dd64d2b752993a59923'
      ],
      kxz:['60b583ea4c6ff9c75eda','1d4996fec21daddd41d5','f8f3e58799f9cb4a91f3','feb6e417b089074784c6'],
      kxztoken:['addcfe8dbc42cc958b30938a5e77abcbebc8b5a800c02ae7b7ffde4ed1032b76'],
      xiaoqing1:['6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7','bebae681e51f6c6d61181a1068bd861766755848946f1839d649ca4933378a86','e18203affbefa3ae8a544f4932ba0c816acdee42026cebaccad62af898f1480b'],
      zjwc1:['a84d159a9cd6f2a605c4','ed8613d1bf8d958506bc',
        '87120a5bd5bf5aa59401','d072259f4d71223acd7d','79ae6653fec4d52adcd4',
        '6ca615644f81185d6e96','0c44704fdc2737a4d558','87dd7700626af2ad6d3d',
        'bfb7879db7d3a4093e77','90a03be22dbe2759a0aa',
        'f968210b86dab904086f','5ab661316f72070deaf0','19e6fa47dd929de27ad8',
        'b27d0972026739b261bf','0f9cbee492464e4e4a17','4ebb948ef42b3a87fc87','869848686a6f212b4724',,'c1b9a00ad201562b7fa8',
        '2f3661ee5b8694d88962','d30d15e9b9f6cae42db6','d8fa938659c2c3469fc8','27835810b269a2a52a8c','f7a036a8d223d75afe81','44dc46018f2d15e92013','8c1929ef18bd13d2ddd9','28411c4368e8e1f8d0f3','71e83a8b3ab5a0ed70e4','0d5e408822bf5c6f81f6','a315a1ed1a80d3333a37','673e48cf1b2f06cdaa8b','34e511b041e1259812f3','28b20dc9bd93a7d326cf','d2b84620a498d3d6d167','8ba3b20a6e2026523d63','32b2963dd5f1039d07b4'],
      sl:['ba0320498117bf425ed56b56f009d7de982e9eeb4699d9d957a10bf6232b51cc','6e14bf7663fb6c736e7b3468009ba242cb434ca25ce38533cd4570406ed8982e','74867f90966baae7d6717a4d96e65b7cbde2b7007516393505f21395afae238b'],
      ljs:['04dcc1ac044f5466618e',
        '7da06d3f391f388afe28',
],
      ywd:['28089746e313f2bfeac5','562923d04c6fdc3e1ada','151b651a7c4f5098dada','3a44caf3c943c0af56aa','a5fe9ce6da661d3d1531','96f898521c3c57659e00'
      ,'e998d3f9bbce51031ea8','6ab8e6baea60a82540a2','b550ed9f57da1157a8c2','78e5812a91c0404e70d7',
        '671ddadf6a9ff41bb3d5','9c124ac4565817db8a19'
      ],

      ywdtoken:['8b62a5877c9b9cf18a1e43e1fd2319e620fcd84626d7d1446577a41eb358a39e'],
      bxmcid:[
        '58a6c23c77cb50537424',
        '7f565c0f595057aea631',
        '84dcd5de5510cd138be5',
        'cf877812a7838de38289',
        'a6ff9f2aca61d7010405'
      ],
      bxmtoken:['71295861e1a888d6e9e0de934b0ec9473e81e781647018d3bbf8f2ce7d9d6c03'],

      wdohx:[
        'a7c82245cd8958a790c8',
        '53739f155f2daafa63dc',
        '1169ff42dafdaa345849',
        'b27e15ae662b1eb091bc',
        '34fe574fdd3ba179c0ab',
        'db5cb7b235d4504a63cb',
        '61eaea5facc044b8ea57',
        '1c361dacad45f1aa92be',
        'a3b019c58b54bc4892dd',
        'f550be30d9309f361cf2',
        'bd07751b580427270ee2',
        '91393c1c8f28f46090f0',
        'b7cc1f1dda74e1703346',
        '0a1dafea7d57337f9456',
        'da6d8f7ef9f871e605e3',
        'a40e1337ae8371ffc6e2',
        'f3b7be50bab4aba06437',
        '078df62967fb4db6cd4a',
        '25e55a8232bef06d2f18',
        '54fe22d4b8469ad4e19f',
        'ff6d251b5d45286864f6',
        '90b6ef559cdc2c69bdd9',
        'ed8b7b8bd5c5af11ee97',
        '9fe32bb5620fe71ba2d3',
        '79c8d86e6c5ddcb823ac',
        '6991256aa7e4d306f5f9',
        'b963f8f65e8a1bc1daea',
        '9d73a4c03808c4992425',
        '90a4ffc5e72e2b1f2089',
        '26bae943303ca7f8e42d'
      ],
      wdohxtoken:['84ef57d56cc1a5f644dcca9e80bf1de12232ab78612dd07687781b1020ab2fdd'],


            bxmbj:[
              '4b6852cd7a350f478bf4',
              'f2701066ee89e1256d89',
              'cf35e0bcfbdb9612fc60',
              '300eb625751e8af76318',
              '741c6fc52734c5c64de6',
              'c5d46f5e05c5ee18d347',
              '06afd201fdcba4eb59dd',
              'cda88734ee90ddc5829a',
              '8f44eee28eb5ee429827',
              'cc70926274ba1dacd9ab',
      ],
      bxmbj1:[
        '3416885919173088ee61',
        '9ec716dfb737e6c3c826',
        'e36a35d1c4dfc4ce8333'
      ],

      bxmbjtoken:['8fb1fcbe314c7df6bb0f195d00df618163463f8409b883c1b8dedae91556c951','132e19269c1e2b814180feac126929249b4c6acc444d14fdf48052c2f7ccf533'],

      ljstoken:['d94b163c7c640fb3efecc297bfe7cc83a43469baf19964a89dfec075d2e79c11'],
      fjwctoken:['9b55a36056fc763032940328e0591cca386bf6b186d710e9f01ed275154a96f8'],
      fjwc:['b0ced990246896269f35','48ade4a1456272e488d8'],
      jsgx:['208538fad40c9796ec00','08de207541e54d033eb7','66046cfed9f87891115e','f0760f6cfe8d319e3bef','a1254894a9a764c6816b','8625b7a0955d398442a4','d1d4707e543526a059e2','480ea6b22f8ffa50e136','0e2399938ab77f5b91cc'],
      jstb:['f3d4eb9d4acfeccbd1bf','6888ae8ac48159ec2fa3','dce582c5ba18e4763eb6','9855ab445099a15b00e7','78e3e38db1293782c583'],
      ysgx:['391b5dcc472a455ee11a','a63cb5bef5ba42c15e4d','11b17535437b9a60273e','3083aa0fa749ebf5d699'],
      zuoen:['c2a16d4047d3d096b2700701fb5caba784e3c1031903fc8207b97b56909ab7a7','677a562f3f2199cc19b5766d0bc49607244909de69ccf16bde768b257f4e3e1f'],
      zuoen1:['89fd201ce92c984ebc93d8bb1dc013c742824a8ffdcb514264ed6b17ce936764','08e14aa03641e9db67b9e0cd228d6439cbd5686ce8614457851412512b33c7f0','7b30f0ddce7f01ddfaf6f6e97b2ee65f3f0cd790afc353f52d8a8d9d0457872d',
      '2530ec7d33530dde21b2fc6ef7c9a6cb9747623e2666bac1d1b2d16f937279de'],
      marryu:['873a63615f6e42478a3b','1c96ea51e138b5a10655','01739c18a49cff216f35','d9dadce1a1edf45a862d','a99e101d860a977cb6dd','baa7f15045eed2cf32d5','a680ac6de646625476d8','43b9070eef1e821e8c40','a6c8a3c6ee3b485291a2','d44f8e9de9fe87c5b8e1','80a0a4124a05fca5856c'],
      dzkq:['92518a6e98167df30da6','223131c857d8d8a6d740','c63f48d65ba25c006be9','4457886dc32340d3e384','e0adca87507d9063c998','bade70f599b0a6bb7b93','b3f89abf9a82b7e07e61','99d2f66e22f5b9e1835c','3ac43da0302e980f73b3'
        ,'af2dfed3df1f91d843a8'
      ],
      dzkqtoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],
      tabj:[
        'ca878fe77b25be88cd6f',
        '51cb7a84cebc03df723f',
        '9858d95a9331a91fbb2e',
        'c40cd319da32b291525c',
        '5791b1fcde66570c161a',
        'fb13bbc48e1b8491f1bd',
        '1cc3fb5f23c92aef24fa',
        'd074deb31c47c9cd3be5',
        '330b55fe69c91f3500fc',
        'f0c2b56d6a01d4e4dff4',
        '7054cbb2a2bafb7eb2fc',
        '5552f2dac226241b733d',
        'b9594b60a54b57a29ade',
        '68831ee1c573e7941da0',
        '0b7072a38d904913e531',
        'a82995099a7d8b388b97',
        '6c63ba088727e9a43650',
        '2498a4f1e110e9fe7120'
      ],

      tabjtoken:['66f73b31f40efb79217611178acdf9313f9a308fa89f9350f31b0b665a06c794'],
      tangtang:['6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7','9b55a36056fc763032940328e0591cca386bf6b186d710e9f01ed275154a96f8','a823e200bc8f6a8edbbb56335c65ef65aa9bfa6e67f902ef073a28c97608ee71'],
      zjwc: ['d58d2e06d91f1fcc1734'],
      czdjf:['974b2af9ce82fb9054c1','603f8017582c594264fa','23eecc162155e27b0c98','ed1f62e5df2cc67e84c1','885795bb61ac63a051bc',
        'b17c0a785621b17b9313','cc5d511d0827bec25998','e08b52f4beaffd5b90ce','c1f1516e55779ab72b34','6e4ec6a2bc0566a7304d'],
      fjwc1:['9db7b3816397c12af284','a66e2afd3fd50539e5ec','9071fd2d5b9b757b9b2d','2626b6fcdf4d91dff0fc','091fe378ca7aa0bb5c94','103e87eb2d92bc66047b','391b5dcc472a455ee11a','a63cb5bef5ba42c15e4d'],
      hy:['f6763ef4c7cca7225efb','d09cf958a84e5de25416','6f963ee7ef2204842267','50ac080cad4cff36ffc3','df7d6ac7df84f181a688','a25ab586a3553ff8eaf1','9deac08f2e3673ad300f','feaf67bcda0c309738ef','3d0b2634f608542d1192','4eaf5ef1fd96e08adae5','a792ffc806e9f33e292f','b2e529e765d0b0e5912e','906401571e91d8291402', '524b9ab96ac72038628f','2a5ce625e65e99284120','e3d11badf345bc4f0741',
        '0d98a87a735b5c65f336','17508515f18f416f5e59','c0603a5cb631ed0be6da','b8db99e2656e2a0ec32f','4357fefbc7f2e33ad75c','2881c6532d20213bde56', '830165add00acbf602b7','f328ba502923cf699f5d','73673fbd251d2b0124d9','2b68fce0d791a7fbc6da'],
      lgyy:['9e5bc7961c87caf15382',
        '127d68b95ffbbc8aa5f6',
        '3d2d556a0a9e4023dedc',
        '47e500b2459cc98e3ffa',
        '7d088caf6ccd8ec3f40c',
        '0041a700ec28e2e4b694',
        '1a93e9823ab7d73fcfda',
        '36fcd335e8c7300cfd2c',
        'fa52b02dbb33074f5102',
        '0fbf6b479ba0fda5d4ec',
        '7e6ef1b4f8a8016a15a8',
        '014c4a448969eba940fa',
        'e40ecb8b470b6c160296',
        '46d51cfb833588788c4a',
        '8af8db0bdf6364a104b0',
        'fc9a396b38892e552cdc',
        '65e6d2cca6d3b9181a0f',
        '849deaab40e5157e7c9d',
        '630de193a5e1eaa35982',
        '0afd5941cbbb0b07c070'],

      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      money:200,
      value3:'',
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        flag:false,
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],
      playCode:[],
      TempData:[],
      table:false,
      dialog: false,
      dialog1:false,
      HourList:[],
      Hourmap:new Map,
      sums:0,
      flag:true,
      form:[],
      group:{},
      kaiguan:0,
      activeName: 'first',
      grouplist:{},
      dingshi:true,
      xiane:true,
      sks:''


    }
  },

  methods:{
    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }

    },

    //限额方法提交
    updateEd(){
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }else {
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }


      this.dialog1=false

    },

    //投放时间方法提交
    updateTime(){
      let endtime='2038-01-19'
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }
      else {
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }

      this.dialog = false
    },

    //限额
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog1=true
    },

    //投放日期
    edit(row){
      this.grouplist={}
      this.grouplist={
        userId:row.userId,
        groudId:row.groupId
      }

      this.dialog=true
      return row
    },

    //显示表单
    handleClick(row){
      this.HourList=[],
        this.TempData=[],
        this.TempData.push(row)
      for (let key=1;key<=this.Hourmap.size;key++){
        // console.log(this.Hourmap.get(key))
        for (let keys=0;keys<this.Hourmap.get(key).length;keys++){
          // console.log(this.TempData.campaignId)
          if(this.Hourmap.get(key)[keys].campaignId===this.TempData[0].campaignId){

            this.HourList.push(this.Hourmap.get(key)[keys])
          }
        }
      }
      let str=[{
        nameid:'',
        balance:'',
        chengben:''
      }];
      str[0].nameid=this.TempData[0].nameid;
      str[0].balance=this.TempData[0].balance;
      for(let i in this.HourList){
        console.log(this.HourList[i].spent)
        console.log(this.HourList[i].formsubmitCount)
        if (this.HourList[i].formsubmitCount===0){
          str[0].chengben=this.HourList[i].spent
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }else {
          str[0].chengben=this.HourList[i].spent/this.HourList[i].formsubmitCount
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }


        this.HourList[i]=this.hb(this.HourList[i],str[0])
      }
      this.table=true



      // get发送请求获取本条的投放时间
      // 生成折线图


    },

    //切换开关
    changeSwitch(value,row,index){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      const { id,pauseState,userId} = row
      let params = {
        userId:userId,
        id:id,
        pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
      };

      this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+this.sks+'&timestamp='+
        time1+'&nonce='+nonce+'&advertiser_id='+params.userId,{
        ids:params.id,
        startAndStop:params.pauseState
      }).then(async res=> {
        if (res.data.code === 0) {
          this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
        }
      })

    },

    //限额显示的规则
    rule1(row,column){
      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },

    //总汇规则
    getSummaries(param) {
      // console.log(JSON.stringify(param)+ '总汇规则参数')
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }

          if (index === 16) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="CAMPAIGN"){ //计划层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }
          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(2);
            sums[index]=sums[index]/10
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }     if (index === 12) {

            return;

          }
          if (index === 14) {
            sums[index] = sums[index-5]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 16) {
            sums[index] = sums[index-7]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 18) {
            sums[index] = sums[index-9]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 19) {

            return;

          }if (index === 20) {

            return;

          }

          if (index === 21) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }
    },

    //导出表单api
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },

    //规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },

    //查询时间选择器函数
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },

    //渲染data、数据处理通用方法
    windowList(){
      //渲染页
      this.temp=JSON.parse(JSON.stringify(this.datadata))
      this.temp1=JSON.parse(JSON.stringify(this.namedata))
      this.temp3=JSON.parse(JSON.stringify(this.playCode))
      for (let key = 0; key < this.temp.length; key++) {
        this.ctrJson[0].flag=false;
        let t=0;
        this.ctrJson[0].nameid=this.temp1[key].name
        this.temp1[key].balance = this.temp1[key].balance / 100000
        this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
        if (this.temp2[key].spent===0){
          this.ctrJson[0].but=0
        }else if (this.temp2[key].formsubmitCount===0){
          this.ctrJson[0].but=this.temp2[key].spent
        }else {
          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
        }

        this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
        this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
        let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
        this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);



        this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
        this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
        let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
        this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
        this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
        this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
        let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
        this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdycl=0
        }else if (this.temp2[key].customRetainCount===0){
          this.ctrJson[0].zdycl=this.temp2[key].spent
        }else {

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
        }




        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdyff=0
        }else if (this.temp2[key].customPayCount===0){
          this.ctrJson[0].zdyff=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
        }


        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdylh=0
        }else if (this.temp2[key].reactivation===0){
          this.ctrJson[0].zdylh=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
        }




        //  限额提醒代码
        if(this.temp3[key].dailyBudget!=-1){
          t=this.temp3[key].dailyBudget/100000
          t=t*0.8
          if (this.temp2[key].spent>=t){
            this.ctrJson[0].flag=true;
          }
        }
        this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
        this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])
      }
      this.temp2=JSON.parse(JSON.stringify(this.temp2))
      this.datas=this.temp2
      console.log(this.temp2)
      this.isDisable = false
      if (this.value==="DAY"){
        this.flag=false;
        if (this.values==="GROUP"){
          this.dingshi=true;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=true;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }else if (this.value==="HOUR"){
        this.flag=true;
        if (this.values==="GROUP"){
          this.dingshi=false;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=false;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }

      this.loading=false
    },


    //查询广告效果api
    async PostListQuery(parms){

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {
          if (resp.data.code!==60806) {
            if (resp.data.data.items != null) {
              if (this.value === "HOUR") {
                // 存取小时的数据[]
                this.sums = this.sums + 1;
                console.log(resp.data.data.items)
                this.Hourmap.set(this.sums, resp.data.data.items)

                // console.log(this.Hourmap.get(parms.a))
                let arr = [];
                let map = new Map;
                for (let key in resp.data.data.items) {
                  var time = new Date(resp.data.data.items[key].reportTime)
                  let reTimeHour = time.getHours(); //获取返回整点时间
                  var date = new Date()
                  let hour = date.getHours();  // 获取当前时间
                  if (hour === reTimeHour) {
                    arr.push(key)   //定位现在整时位置
                    map.set(key, resp.data.data.items[key])// 记录下现在的数据
                  }
                }
                for (let keys in arr) {

                  this.datadata.push(map.get(arr[keys]))
                  let obj = {
                    ids: resp.data.data.items[arr[keys]].campaignId,
                    lengths: arr.length
                  }
                  let pams = Object.assign(obj, parms)
                  await this.PostListplayCode(pams)
                }
                let obj1 = {
                  lengths: arr.length
                }
                parms = Object.assign(obj1, parms)
                await this.GetListUserId(parms);

              } else {
                console.log(resp.data.data.items)
                for (let b = 0; b < resp.data.data.items.length; b++) {
                  this.datadata.push(resp.data.data.items[b])
                  let obj = {
                    ids: resp.data.data.items[b].campaignId,
                    lengths: resp.data.data.items.length
                  }
                  let pams = Object.assign(obj, parms)
                  await this.PostListplayCode(pams)
                }
                let obj1 = {
                  lengths: resp.data.data.items.length
                }
                parms = Object.assign(obj1, parms)
                await this.GetListUserId(parms);

              }

            }
          }
      })

    },

    //修改限额api
    async PostGroup(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success'
          });
        }

      })


    },

    //修改投放日期api
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,

        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });
          this.getDataList()
        }

      })


    },
    //查询账号信息api
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {
            }
          }

        )
    },
    // 查询计划状态api
    async PostListplayCode(pams){
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          console.log(resps.data.data.list[0])
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },
    getDataList() {
      this.loading=true
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]
      if(this.userUalue[0]==="tangtang"){
        this.isDisable = true
        this.TimeChange();
      }else if(this.userUalue[0]=="zuoen"){
        this.isDisable = true
        this.TimeChangetozuoen();
      }else if(this.userUalue[0]="xiaoqing"){
        this.isDisable = true
        this.TimeChangetoxiaoqing();
      }
    },
    async TimeChange () {
      if (this.userUalue[1]==="fjwc"){
        console.log(this.value)
        for (let a = 0; a < this.fjwc.length; a++) {

          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.tangtang[1] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.fjwc[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            console.log(resp.data.data)

            if (resp.data.data.items != null) {
              // 追加数据
              console.log(resp.data.message)

              this.$message.success("正在查询第"+a+"条数据")
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.tangtang[1] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.fjwc[a])
                .then(res => {
                  console.log(res.data.message)
                  if (res.data.message == '请求成功') {
                    this.namedata.push(res.data.data)
                  } else {
                    console.log(res.data.message)
                  }
                })
            }
          })
        }
        //渲染页面
        setTimeout(()=>{
          this.temp=JSON.parse(JSON.stringify(this.datadata))
          this.temp1=JSON.parse(JSON.stringify(this.namedata))
          for (let key=0;key<this.temp.length;key++){
            this.temp1[key].balance=this.temp1[key].balance/100000
            this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
            this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR=this.temp2[key].formsubmitCount/this.temp2[key].clickCount
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);


            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);


            this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          }
          setTimeout(()=>{},1000)
          this.datas=this.temp2
          this.isDisable=false
        },3000)

      } else if(this.userUalue[1]=="hy"){

        for (let a = 0; a < this.hy.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.tangtang[2] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.hy[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {

            if (resp.data.data.items != null) {
              // 追加数据

              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }

              this.$message.success("正在查询第" + a + "条数据")
              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.tangtang[2] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.hy[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)
                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            //自定义次留成本

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);



            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])




          }

          this.datas = this.temp2
          this.isDisable=false
        }, 4000)
      }


      else if(this.userUalue[1]="zjwc"){

        for (let a = 0; a < this.zjwc.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.tangtang[0] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.zjwc[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第"+a+"条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.tangtang[0] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.zjwc[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页面
        setTimeout(()=>{
          this.temp=JSON.parse(JSON.stringify(this.datadata))
          this.temp1=JSON.parse(JSON.stringify(this.namedata))
          for (let key=0;key<this.temp.length;key++){
            this.temp1[key].balance=this.temp1[key].balance/100000
            this.temp2[key]=this.hb(this.temp1[key],this.temp[key])


            this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR=this.temp2[key].formsubmitCount/this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])

          }

          this.datas=this.temp2
          this.isDisable=false
        },4000)

      }

    },
    async TimeChangetozuoen () {
      if (this.userUalue[1]==="marryu"){

        this.sks=this.zuoen[0]
        this.sums=0;
        for (let a = 0; a < this.marryu.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.marryu
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="kxz"){

        this.sks=this.kxztoken[0]
        this.sums=0;
        for (let a = 0; a < this.kxz.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.kxz
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="tabj"){

        this.sks=this.tabjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.tabj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tabj
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="dzkq"){
        this.sks=this.dzkqtoken[0]
        this.sums=0;
        for (let a = 0; a < this.dzkq.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.dzkq
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }

      if (this.userUalue[1]==="jqsq"){
        this.sks=this.jqsqtoken[0]
        this.sums=0;
        for (let a = 0; a < this.jqsq.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jqsq
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="cpcid"){
        this.sks=this.cpcidtoken[0]
        this.sums=0;
        for (let a = 0; a < this.cpcid.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.cpcid
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="bxmcid"){
        this.sks=this.bxmtoken[0]
        this.sums=0;
        for (let a = 0; a < this.bxmcid.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bxmcid
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="wdohx"){
        this.sks=this.wdohxtoken[0]
        this.sums=0;
        for (let a = 0; a < this.wdohx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.wdohx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="bxmbj"){
        this.sks=this.bxmbjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.bxmbj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bxmbj
          }
          await this.PostListQuery(parms)
        }



        this.sks1=this.bxmbjtoken[1]
        this.sums=0;
        for (let a = 0; a < this.bxmbj1.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks1,
            adid:this.bxmbj1
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="ywd"){
        this.sks=this.ywdtoken[0]
        this.sums=0;
        for (let a = 0; a < this.ywd.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ywd
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="ygxys"){
        this.sks=this.ygxystoken[0]
        this.sums=0;
        for (let a = 0; a < this.ygxys.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ygxys
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="zhmc"){
        this.sks=this.zhmctoken[0]
        this.sums=0;
        for (let a = 0; a < this.zhmc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zhmc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="ylmc"){
        this.sks=this.ylmctoken[0]
        this.sums=0;
        for (let a = 0; a < this.ylmc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ylmc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="xyxys"){
        this.sks=this.xyxystoken[0]
        this.sums=0;
        for (let a = 0; a < this.xyxys.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.xyxys
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="hxbj"){
        this.sks=this.hxbjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.hxbj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.hxbj
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="smyxys"){
        this.sks=this.smyxystoken[0]
        this.sums=0;
        for (let a = 0; a < this.smyxys.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.smyxys
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      if (this.userUalue[1]==="czdjf"){

        this.sks=this.sl[1]
        this.sums=0;
        for (let a = 0; a < this.czdjf.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.czdjf
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="hmhx"){

        this.sks=this.hmhxtoken[0]
        this.sums=0;
        for (let a = 0; a < this.hmhx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.hmhx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="xmmc"){

        this.sks=this.xmmctoken[0]
        this.sums=0;
        for (let a = 0; a < this.xmmc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.xmmc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="xmlmc"){

        this.sks=this.xmlmctoken[0  ]
        this.sums=0;
        for (let a = 0; a < this.xmlmc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.xmlmc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="fkysk"){

        this.sks=this.fkysktoken[0  ]
        this.sums=0;
        for (let a = 0; a < this.fkysk.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.fkysk
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="zjwc1"){
        this.sks=this.xiaoqing1[0]
        this.sums=0;
        for (let a = 0; a < this.zjwc1.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zjwc1
          }
          await this.PostListQuery(parms)
        }
        for (let a = 0; a < this.fjwc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.fjwctoken,
            adid:this.fjwc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      if (this.userUalue[1]==="ysgx"){
        for (let a = 0; a < this.zuoen1.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.zuoen1[a] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.ysgx[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.zuoen1[a] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.ysgx[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页面

          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
            this.ctrJson[0].nameid=this.temp1[key].name

            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }
          this.loading=false
          this.datas = this.temp2
          this.isDisable = false

      }

      if (this.userUalue[1]==="lgyy"){
        this.sks=this.zuoen[1]
        this.sums=0;
        for (let a = 0; a < this.lgyy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.lgyy
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="ljs"){
        this.sks=this.kxztoken[0]
        this.sums=0;
        for (let a = 0; a < this.ljs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ljs
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
    },



    async TimeChangetoxiaoqing () {
      if (this.userUalue[1]==="ysgx"){

        for (let a = 0; a < this.xiaoqing.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.xiaoqing[a] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.ysgx[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.xiaoqing[a] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.ysgx[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面

        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }

          this.datas = this.temp2
          this.isDisable=false
        }, 4000)



      }
      if (this.userUalue[1]==="zjwc1"){

        for (let a = 0; a < this.zjwc1.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.xiaoqing1[0] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.zjwc1[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }               this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.xiaoqing1[0] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.zjwc1[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面

        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          }

          this.datas = this.temp2
          this.isDisable=false
        }, 4000)


      }
      if (this.userUalue[1]==="jsgx"){

        for (let a = 0; a < this.jsgx.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.xiaoqing1[1] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.jsgx[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.xiaoqing1[1] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.jsgx[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页面
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }

          this.datas = this.temp2
          this.isDisable=false
        }, 4000)



      }
      if (this.userUalue[1]==="jstb"){

        for (let a = 0; a < this.jstb.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.xiaoqing1[2] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.jstb[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.xiaoqing1[2] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.jstb[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面


        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }

          this.datas = this.temp2
          this.isDisable=false
        }, 4000)



      }

    },
  },
  created () {  },
}
</script>







// WEBPACK FOOTER //
// src/components/zen.vue